import React, { useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Select, FormControl,
    InputLabel, RadioGroup, FormControlLabel, Radio,
    Box,
    Typography
} from "@mui/material";
import BASE_URL, { COMMUNITYADMINS } from "../../NetworkConfig/ApiConfig";

const RemoveCMFromSpace = ({ open, onClose, data, onDelete= () => {} }) => {
    

    return (
        <Dialog open={open} onClose={onClose} >
            <DialogTitle style={{ background: "#202020", fontFamily: "poppins-reg" }}>Remove community from space</DialogTitle>
            <DialogContent style={{ background: "#202020" }}>
                <Box sx={{display: 'flex', flexDirection:'column'}}>
                    <Typography style={{fontSize: "14px", marginBottom: "20px", fontFamily: "poppins-reg", width: "400px"}}>Are you sure you want to remove {data.title} from this space?</Typography>
                    <DialogActions>
                        <Button onClick={onClose} style={{ fontFamily: "poppins-reg", color: "#ffffff" }}>Cancel</Button>
                        <Button onClick={() => { onDelete(data) }} style={{ fontFamily: "poppins-reg", color: "red", border: "0px solid #ff220040",
                            background: "#ff220020"
                         }} variant="none">Remove</Button>
                    </DialogActions>
                </Box>

                    
            </DialogContent>
        </Dialog>
    );
};

export default RemoveCMFromSpace;
